/* ============================================================
   PRODUCT HERO — GSAP + THREE.JS (SHOPIFY SAFE)
============================================================ */

(function initProductHero() {
  const heroSection = document.querySelector("[id^='product-hero-']");
  if (!heroSection) return;

  const modelContainer = heroSection.querySelector(".hero-model-container");
  const bgTitle = heroSection.querySelector(".product-hero-bg-title");
  const fgTitle = heroSection.querySelector(".product-hero-main-title");

  if (!modelContainer) return;

  const modelURL = modelContainer.dataset.modelUrl;
  if (!modelURL) return ;

  if (!window.THREE) return console.error("[Hero3D] THREE not loaded");
  if (window.gsap && window.ScrollTrigger) {
    gsap.registerPlugin(ScrollTrigger);
  }


  /* ============================================================
     A) TITLE INTRO (simple)
  ============================================================= */
  if (fgTitle && window.gsap) {
    gsap.fromTo(
      fgTitle,
      { opacity: 0, y: 60 },
      { opacity: 1, y: 0, duration: 1.0, ease: "power3.out" }
    );
  }

  // IMPORTANT: your CSS makes container opacity:0, so force it visible if anything fails
  modelContainer.style.opacity = "1";
  modelContainer.style.transform = "translateY(0)";

  /* ============================================================
     B) THREE SETUP
  ============================================================= */
  const scene = new THREE.Scene();

  const width = modelContainer.clientWidth || 800;
  const height = modelContainer.clientHeight || 500;

  const camera = new THREE.PerspectiveCamera(35, width / height, 0.01, 2000);
  camera.position.set(0, 0, 6);

  const renderer = new THREE.WebGLRenderer({
    antialias: true,
    alpha: true,
    powerPreference: "high-performance"
  });

  renderer.setClearColor(0x000000, 0);
  renderer.setSize(width, height);
  renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
  renderer.outputColorSpace = THREE.SRGBColorSpace;

  modelContainer.appendChild(renderer.domElement);

  // Lights (needed for StandardMaterial)
  scene.add(new THREE.AmbientLight(0xffffff, 1.1));
  const dir = new THREE.DirectionalLight(0xffffff, 1.3);
  dir.position.set(2, 2, 3);
  scene.add(dir);

  /* ============================================================
     C) LOAD MODEL
  ============================================================= */
  let model = null;
  let baseScale = 1;
  let floatTime = 0;

  const loader = new THREE.GLTFLoader();

  loader.load(
    modelURL,
    (gltf) => {
      model = gltf.scene;
      scene.add(model);


      // ensure meshes render
      model.traverse((child) => {
        if (child.isMesh) {
          child.material = new THREE.MeshStandardMaterial({
            color: 0xffffff,
            roughness: 0.5,
            metalness: 0.15,
            side: THREE.DoubleSide
          });
          child.material.needsUpdate = true;
        }
      });

      // Center model
      const box = new THREE.Box3().setFromObject(model);
      const size = box.getSize(new THREE.Vector3());
      const center = box.getCenter(new THREE.Vector3());
      model.position.sub(center);

      // Compute baseScale (final scale)
      const maxDim = Math.max(size.x, size.y, size.z) || 1;
      const targetSize = 6;
      baseScale = targetSize / maxDim;

      // CINEMATIC START POSE (tilted + bigger + lower)
      const isMobile = window.innerWidth < 768;
      const tiltX = isMobile ? -0.45 : -0.60;
      const scaleBoost = isMobile ? 1.35 : 1.60;

      model.rotation.set(tiltX, 0.45, 0);
      model.position.y = -2.0;
      model.scale.setScalar(baseScale * scaleBoost);

      // Camera fit
      const fov = camera.fov * (Math.PI / 180);
      let cameraZ = (targetSize / 2) / Math.tan(fov / 2);
      cameraZ *= 1.6;
      camera.position.set(0, 0, cameraZ);
      camera.lookAt(0, 0, 0);
      camera.near = cameraZ / 100;
      camera.far = cameraZ * 100;
      camera.updateProjectionMatrix();


      // ============================================================
      // ✅ SCROLL ANIMATION (ONLY AFTER model exists)
      // ============================================================
      if (window.gsap && window.ScrollTrigger && bgTitle) {
        // start state: only title visible
        gsap.set(modelContainer, { opacity: 0, y: 250 });

        const tl = gsap.timeline({
          scrollTrigger: {
            trigger: heroSection,
            start: "top top",
            end: "+=160%",
            scrub: true,
            pin: true
          }
        });

        // model rises up into view
        tl.to(modelContainer, { opacity: 1, y: 0, ease: "power3.out" }, 0);

        // bg title stays but goes behind vibe
        tl.to(bgTitle, { opacity: 0.10, scale: 0.98, ease: "none" }, 0);

        // model zooms out + stands up in middle
        tl.to(model.scale, { x: baseScale, y: baseScale, z: baseScale, ease: "power2.out" }, 0.55);
        tl.to(model.rotation, { x: 0, y: 0, z: 0, ease: "power2.out" }, 0.55);
        tl.to(model.position, { y: 0, ease: "power2.out" }, 0.95);

      } else {        
        modelContainer.style.opacity = "1";
      }

      animate();
    },
    undefined,
    (err) => console.error("[Hero3D] GLB load failed", err)
  );

  /* ============================================================
     D) RENDER LOOP (float + rotate only after settle)
  ============================================================= */
  function animate() {
    requestAnimationFrame(animate);

    if (model) {
      floatTime += 0.01;

      // gentle idle motion
      model.position.y += Math.sin(floatTime) * 0.0015;
      model.rotation.y += 0.002;
    }

    renderer.render(scene, camera);
  }

  /* ============================================================
     E) RESIZE
  ============================================================= */
  window.addEventListener("resize", () => {
    const w = modelContainer.clientWidth || 800;
    const h = modelContainer.clientHeight || 500;
    renderer.setSize(w, h);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
  });
})();
